import { render, staticRenderFns } from "./teacher-profile.vue?vue&type=template&id=7acdb50e&scoped=true&"
import script from "./teacher-profile.vue?vue&type=script&lang=js&"
export * from "./teacher-profile.vue?vue&type=script&lang=js&"
import style0 from "./teacher-profile.vue?vue&type=style&index=0&id=7acdb50e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acdb50e",
  null
  
)

export default component.exports